import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import AvatarGenerator, { AvatarData } from './AvatarGenerator';

interface AvatarModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (avatarData: AvatarData) => void;
  initialAvatar?: AvatarData;
}

const AvatarModal: React.FC<AvatarModalProps> = ({ 
  isOpen, 
  onClose, 
  onSave,
  initialAvatar
}) => {
  const handleSaveAvatar = (avatarData: AvatarData) => {
    onSave(avatarData);
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black z-40"
            onClick={onClose}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            className="fixed inset-0 z-50 flex items-center justify-center p-4 max-w-[100vw]"
          >
            <div className="bg-white dark:bg-dark-800 rounded-xl shadow-xl max-w-md w-full max-w-[calc(100vw-2rem)]">
              <div className="p-4 sm:p-6">
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                    Create Your Avatar
                  </h3>
                  <button
                    onClick={onClose}
                    className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
                  >
                    <X className="h-5 w-5" />
                  </button>
                </div>
                
                <AvatarGenerator 
                  onSelect={handleSaveAvatar}
                  initialAvatar={initialAvatar}
                />
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default AvatarModal;